<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">集中器名称：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">集中器编号：</span>
        </div>
        <el-input v-model="formData.serialNo" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">厂家：</span>
        </div>
        <el-input v-model="formData.factory" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">类型：</span>
        </div>
        <el-input v-model="formData.type" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">状态：</span>
        </div>
        <el-input v-model="formData.status" size="small" style="width: 280px" />
      </div>
    </form>
    <div class="form-btn-box">
      <button-confirm @confirm="confirm" />
      <button-cancel @cancel="cancel" />
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Lock";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "lock-authorization-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧门锁",
          name: "lock-concentrator-manage"
        },
        {
          value: "权限管理"
        }
      ],
      mainTitle: "添加权限",
      subheading: "",
      formData: {},
      equipmentCode: "",
      equipmentList: []
    };
  },
  created() {
  },
  methods: {
    confirm() {
      this.$axios
        .post(api.addAuthorized, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "lock-authorization-manage"
            });
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.$router.push({
        name: "lock-authorization-manage"
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/GateLock/GateLockAuthorization/LockAuthorizationAdd.vue